import React, { useState, useEffect } from "react";

// import {
//   // getInvocations,
//   getLogData,
// } from "./../../../Common/services/httpservice"; // Import the service function


import { useSelector, useDispatch } from 'react-redux'; // Import useSelector and useDispatch
import { getInvocations, getLogData } from '@/Redux/slices/integrationSlice'; // Import the async thunk



import { formatDate, getTimeDiffInSeconds } from "@Common/utils/utils"; // Import the formatDate function

const Invocations = ({ details, onButtonClick }) => {
  const dispatch = useDispatch();

  const runHistory = useSelector((state) => state.integration.runHistory);
  const logData = useSelector((state) => state.integration.logData);
  const status = useSelector((state) => state.integration.status);
  const logDataLoading = useSelector((state) => state.integration.logdataLoadingStatus);
  // const error = useSelector((state) => state.integration.error);

  const [showDropdown, setShowDropdown] = useState(false);
  const [showDropdownMethod, setShowDropdownMethod] = useState(false);

  const [selectedItem, setSelectedItem] = useState(null);

  // const [logData, setLogData] = useState([]);
  // const [logDataLoading, setIsLoadingLogData] = useState(true);
  // const [errorLogData, setErrorLogData] = useState(null);

  useEffect(() => {
    if (!details || !details.integration_id) {
      return;
    }

    dispatch(getInvocations(details.integration_id, 1));
  }, [details]); // Empty dependency array means this runs once on mount

  useEffect(() => {
    if (!selectedItem) {
      return;
    }

    // console.log(selectedItem.run_id);
    dispatch(getLogData(selectedItem.run_id));
    
    // const fetchData = async () => {
    //   setIsLoadingLogData(true);
    //   setErrorLogData(null);
    //   try {
    //     const data = await getLogData(selectedItem); // Fetch the data
    //     setLogData(data); // Update the state with the fetched data
    //   } catch (err) {
    //     setErrorLogData(err);
    //   } finally {
    //     setIsLoadingLogData(false);
    //   }
    // };

    // fetchData();
  }, [selectedItem]); // Empty dependency array means this runs once on mount



  useEffect(() => {
    if (runHistory.length > 0) {
      setSelectedItem(runHistory[0]);
    }
  }, [runHistory]);

  const onClick = () => {
    if (onButtonClick) {
      onButtonClick();
    }
  };

  const onDropDown = () => {
    setShowDropdown(!showDropdown);
  };

  const onDropDownMethod = () => {
    setShowDropdownMethod(!showDropdownMethod);
  };

  // // Function to generate and set the GUID
  // const generateAndSetGuid = () => {
  //   const newGuid = crypto.randomUUID(); // Generate the GUID
  //   setGuid(newGuid); // Update the state with the new GUID
  // };

  // Generate the GUID when the component mounts
  // useEffect(() => {
  //   generateAndSetGuid();
  // }, []);

  const onItemSelected = (item) => {

    setSelectedItem(item);
    // console.log("Selected item:", item);
  };

  // const formatDate = (dateString) => {
  //   const date = new Date(dateString);
  //   const formattedDate = date.toLocaleDateString("en-US", {
  //     month: "2-digit",
  //     day: "2-digit",
  //     year: "numeric",
  //   });
  //   const formattedTime = date.toLocaleTimeString("en-US", {
  //     hour: "2-digit",
  //     minute: "2-digit",
  //     hour12: true,
  //   });
  //   return `${formattedDate} ${formattedTime}`;
  // };

  const StatusIcon = ({ status }) => {
    switch (status) {
      case "Success":
        return (
          <svg className="h-4 w-4" viewBox="0 0 24 24" fill="none">
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g
              id="SVGRepo_tracerCarrier"
              strokeLinecap="round"
              strokeLinejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
              {" "}
              <path
                d="M12 2C6.49 2 2 6.49 2 12C2 17.51 6.49 22 12 22C17.51 22 22 17.51 22 12C22 6.49 17.51 2 12 2ZM16.78 9.7L11.11 15.37C10.97 15.51 10.78 15.59 10.58 15.59C10.38 15.59 10.19 15.51 10.05 15.37L7.22 12.54C6.93 12.25 6.93 11.77 7.22 11.48C7.51 11.19 7.99 11.19 8.28 11.48L10.58 13.78L15.72 8.64C16.01 8.35 16.49 8.35 16.78 8.64C17.07 8.93 17.07 9.4 16.78 9.7Z"
                fill="#15e411"
              ></path>{" "}
            </g>
          </svg>
        );
      case "Failed":
        return (
          <svg
            className="h-4 w-4"
            viewBox="0 0 32 32"
            version="1.1"
            fill="#000000"
          >
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g
              id="SVGRepo_tracerCarrier"
              strokeLinecap="round"
              strokeLinejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
              {" "}
              <defs> </defs>{" "}
              <g
                id="Page-1"
                stroke="none"
                strokeWidth="1"
                fill="none"
                fillRule="evenodd"
              >
                {" "}
                <g
                  id="Icon-Set-Filled"
                  transform="translate(-570.000000, -1089.000000)"
                  fill="#f24545"
                >
                  {" "}
                  <path
                    d="M591.657,1109.24 C592.048,1109.63 592.048,1110.27 591.657,1110.66 C591.267,1111.05 590.633,1111.05 590.242,1110.66 L586.006,1106.42 L581.74,1110.69 C581.346,1111.08 580.708,1111.08 580.314,1110.69 C579.921,1110.29 579.921,1109.65 580.314,1109.26 L584.58,1104.99 L580.344,1100.76 C579.953,1100.37 579.953,1099.73 580.344,1099.34 C580.733,1098.95 581.367,1098.95 581.758,1099.34 L585.994,1103.58 L590.292,1099.28 C590.686,1098.89 591.323,1098.89 591.717,1099.28 C592.11,1099.68 592.11,1100.31 591.717,1100.71 L587.42,1105.01 L591.657,1109.24 L591.657,1109.24 Z M586,1089 C577.163,1089 570,1096.16 570,1105 C570,1113.84 577.163,1121 586,1121 C594.837,1121 602,1113.84 602,1105 C602,1096.16 594.837,1089 586,1089 L586,1089 Z"
                    id="cross-circle"
                  >
                    {" "}
                  </path>{" "}
                </g>{" "}
              </g>{" "}
            </g>
          </svg>
        );
      case "Running":
        return (
          <svg
            className="h-4 w-4"
            viewBox="0 0 32 32"
            version="1.1"
            fill="#000000"
          >
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g
              id="SVGRepo_tracerCarrier"
              strokeLinecap="round"
              strokeLinejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
              {" "}
              <defs> </defs>{" "}
              <g
                id="Page-1"
                stroke="none"
                strokeWidth="1"
                fill="none"
                fillRule="evenodd"
              >
                {" "}
                <g
                  id="Icon-Set-Filled"
                  transform="translate(-570.000000, -1089.000000)"
                  fill="#0000ff"
                >
                  {" "}
                  <path
                    d="M591.657,1109.24 C592.048,1109.63 592.048,1110.27 591.657,1110.66 C591.267,1111.05 590.633,1111.05 590.242,1110.66 L586.006,1106.42 L581.74,1110.69 C581.346,1111.08 580.708,1111.08 580.314,1110.69 C579.921,1110.29 579.921,1109.65 580.314,1109.26 L584.58,1104.99 L580.344,1100.76 C579.953,1100.37 579.953,1099.73 580.344,1099.34 C580.733,1098.95 581.367,1098.95 581.758,1099.34 L585.994,1103.58 L590.292,1099.28 C590.686,1098.89 591.323,1098.89 591.717,1099.28 C592.11,1099.68 592.11,1100.31 591.717,1100.71 L587.42,1105.01 L591.657,1109.24 L591.657,1109.24 Z M586,1089 C577.163,1089 570,1096.16 570,1105 C570,1113.84 577.163,1121 586,1121 C594.837,1121 602,1113.84 602,1105 C602,1096.16 594.837,1089 586,1089 L586,1089 Z"
                    id="cross-circle"
                  >
                    {" "}
                  </path>{" "}
                </g>{" "}
              </g>{" "}
            </g>
          </svg>
        );
      default:
        return <span>&nbsp;</span>;
    }
  };

  const onRefresh = () => {
    dispatch(getInvocations(details.integration_id, 1));
  };


  const LoadingSkeleton = () => {
    return (
      <div className="space-y-2">
        {/* Generate 20 skeleton items */}
        {Array.from({ length: 20 }).map((_, index) => (
          <div
            key={index}
            className="flex animate-pulse space-x-4 border-b border-gray-200"
          >
            <div className="h-8 w-full bg-gray-200 py-2"></div>
          </div>
        ))}
      </div>
    );
  };

  const getTextColor = (logType) => {
    switch (logType) {
      case "Info":
        return "text-[#03bfff]";
      case "Error":
        return "text-red-500";
      case "Warn":
        return "text-yellow-500";
      default:
        return "text-gray-500";
    }
  };


  return (
    <div className="mb-6 rounded-md bg-white-500 pt-4">
      <div className="text-sm">
        <div className="flex text-white">
          <div className="text-lg font-medium">Flow Trail</div>
          <div>
            <button className="ml-2 rounded-md bg-gray-200 p-2 text-gray-900 hover:bg-gray-400" onClick={onRefresh}>Refresh</button>
          </div>
        </div>
      </div>

      <div className="flex space-x-4 py-1 text-white">
        <div className="h-[calc(100vh-290px)] w-1/5 overflow-y-auto">

          {status === "succeeded" && runHistory && runHistory.length === 0 && (
            <div className="bg-theme-tertiary text-white p-2">No data available</div>
          )}

          {status === "loading" && <LoadingSkeleton />}
          {status === "succeeded" && runHistory && runHistory.map((item, index) => (
            <div
              onClick={() => onItemSelected(item)}
              className={`flex text-xs mt-1 -mb-1 border-b cursor-pointer border-gray-200 px-1 ${selectedItem === item ? "bg-theme-tertiary text-white" : ""
                }`}
              key={index}
            >
              <div className="flex w-2/3 space-x-1 py-2">
                <span>
                  <StatusIcon status={item.status} />
                </span>
                <span>{formatDate(item.startedAt)}</span>
              </div>
              <div className="w-1/3 py-2">{getTimeDiffInSeconds(item.completedAt, item.startedAt )} seconds</div>
            </div>
          ))}
        </div>
        <div className="inner-strong-shadow h-[calc(100vh-210px)] w-4/5 overflow-y-auto rounded-md bg-gray-900 p-2 text-white-500">
          {logDataLoading === "loading" && <div>Loading...</div>}
          {logDataLoading === "succeeded" && logData.length === 0 && (
            <div>No log data available</div>
          )}
          {logDataLoading === "succeeded" && logData.map((item, index) => (
            <div
              className="flex px-1 text-xs"
              key={index}
            >
              <div className={`py-0 ${getTextColor(item.logType)}`}>[{formatDate(item.loggedAt)}] - [{item.logType}] {item.logMessage}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Invocations;
